import { SET_USER, CLEAR_USER } from "../constants";
import { User } from "../../interfaces/User";

export type UserType = "inactive" | "seller";

export interface UserAction {
  type: string;
  user?: User | any;
}

export const setUser = (user: User | any) => {
  return {
    type: SET_USER,
    user,
  };
};

export const clearUser = () => {
  return { type: CLEAR_USER };
};
